import { render } from "./BaseCard.vue?vue&type=template&id=85c6e1aa&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=85c6e1aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-85c6e1aa"

export default script